// SEO route eligibility. Deliberately NOT a separate policy: it composes the shared
// public-English catalog cleanup with the shared Zgharta boundary predicate, so the
// prerendered pages can never claim an item the app itself would refuse to show.
// When the catalog policy engine (#217-#222) lands, this composition should migrate
// into it rather than growing its own rules here.
import { isPublicZghartaCatalogItem } from '../domain/index.js';

export { getPublicEnglishCatalogItems } from '../catalog/publicEnglishCatalog.js';

export function toSeoBoundaryCandidate(item) {
  return {
    ...item,
    village: item?.village || item?.location,
    villageAr: item?.villageAr || item?.locationAr,
    latitude: item?.coordinates?.lat,
    longitude: item?.coordinates?.lng,
  };
}

export function isSeoZghartaAttributable(item) {
  return isPublicZghartaCatalogItem(toSeoBoundaryCandidate(item));
}
